'use client';
import { GlobalError as GlobalErrorPage } from '@repo/ui';

export default function GlobalError({ error }: { error: Error & { digest?: string } }) {
  return <GlobalErrorPage error={error} app="customer" />;
}
